module.exports = __webpack_public_path__ + "img/download_google.c9cf2fd8.png";